export default {
  path: '/wecode/form',
  auth: false,
  preload: false,
  key: 'form',
  isStatic: true,
  component: () => import('./index')
};
